export default function PanelsSlider(container) {
	let	wrapper,
		slides,
		slidesCount,
		timeout,
		maxHeight = 0,
		slideWidth,
		currentSlide = 0,
		wrapperPos = 0,
		controls,
		touchPos = 0,
		dragging = false;

	function init(resize) {	

		wrapper = container.querySelector('.panelsSlider-wrapper');
		slides = [ ... wrapper.getElementsByClassName('panelsSlider-slide') ];
		slidesCount = slides.length - 1;
		controls = [ ... container.getElementsByClassName('panelsSlider-dot') ];

		if(resize) {
			for (let i = 0; i <= slidesCount; i++) {
				slides[i].removeAttribute("style");
			}
		}

		if ( ! container || window.matchMedia("(min-width: 768px)").matches) {
			return;
		}

		for (let i = 0; i <= slidesCount; i++) {
			maxHeight = slides[i].clientHeight > maxHeight ? slides[i].clientHeight : maxHeight;
		}

		for (let i = 0; i <= slidesCount; i++) {
			//slides[i].style.height =  maxHeight + 'px';
			slides[i].addEventListener('mousedown', startDrag);
			slides[i].addEventListener('touchstart', startDrag);
			slides[i].addEventListener('mousemove', drag);
			slides[i].addEventListener('touchmove', drag);
			slides[i].addEventListener('mouseup', stopDrag);
			slides[i].addEventListener('touchend', stopDrag);
		}

		for (let i = 0; i < controls.length; i++) {
			controls[i].onclick = () => {
				currentSlide = i;
				setSlide();
			}
		}
	}

	function startDrag(e) {
		if(e.type =="touchstart") {
			touchPos = e.touches[0].clientX;
		}else {
			touchPos = e.clientX;
			dragging = true;
		}
		//dragging = true;
	}

	function drag(e) {
		if(e.type =="touchmove") {
			dragging = true;
		}
		if( dragging ) {
			let delta = 0;

			if(e.type =="touchmove") {
				delta = e.touches[0].clientX - touchPos;
			}else{
				delta = e.clientX-touchPos;
				
			}
			
			wrapper.style.transform = `translate3d(${wrapperPos + delta}px, 0, 0)`;
		}
	}

	function stopDrag(e) {
		
		if( dragging ) {
			let delta = 0;

			if(e.type =="touchend") {

				delta = e.changedTouches[0].clientX - touchPos;
			}else{
				delta = e.clientX-touchPos;
			}
			if (delta==0){
				return;
			}
			if(delta < 0) {
				if(currentSlide < slidesCount){
					currentSlide++;
					//console.log(currentSlide);
				}
				
			}else {

				if(currentSlide > 0){
					currentSlide--;
				}
			}
			setSlide();
		}
		dragging = false;
	}

	function setSlide() {

		wrapperPos = 0;

		for (let i = 0; i < currentSlide; i++) {
			wrapperPos -= slides[i].offsetWidth;
		}
		wrapper.style.transform = `translate3d(${wrapperPos}px, 0, 0)`;

		for (let i = 0; i < controls.length; i++) {
			controls[i].classList.remove('panelsSlider-dot_active');
		}
		controls[currentSlide].classList.add('panelsSlider-dot_active');
	}

	function rem(rem) {    
     return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}

	init();

	window.addEventListener("resize", ()=>{init(true)});
}


// WEBPACK FOOTER //
// ./js/src/PanelsSlider.js